export const PUBLIC_START_URL = "/start";
export const PUBLIC_TEST_URL = "/go";
export const PUBLIC_REPORT_URL = "/report";
export const PUBLIC_GROUP_URL = "/group";
export const CUSTOM_PUBLIC_REPORT_URL = "/creport";
export const CUSTOM_PUBLIC_GROUP_URL = "/cgroup";
export const PUBLIC_COCKPIT_URL = "/cockpit";
export const FUTUREBILITY_COCKPIT_URL = "/futurebility-cockpit";
export const FUTUREBILITY_COCKPIT_INDIVIDUAL_REPORT_URL =
  "/futurebility-cockpit-individual-report";
export const ATTRIBUTES_SUB_URL = "attributes";
export const SPECIAL_ATTRIBUTES_SUB_URL = "special-attributes";
export const PERSONAL_SUMMARY_SUB_URL = "personal-summary";
export const TOPIC_SELECTION_SUB_URL = "challenges";
export const JOURNEY_SUB_URL = "journey";
export const INTRO_SUB_URL = "intro";
export const INTRO_MODULE_SUB_URL = "intro";
export const END_SUB_URL = "end";
export const START_SESSION_ID_SUB_URL = "start";
export const MODULE_SUB_URL_PATTERN = ":module(analytics|reflection|solution)";

export const TEST_TYPES = {
  LIKERT: "L",
  TEXT: "T",
  CHOICE: "C",
  NUMERICAL: "N",
  MULTI_CHOICE: "M",
  SUB_HEADING: "S",
  DoubleSlider: "A",
  SingleSlider: "B",
  WordCloud: "W",
  AreaSlider: "X",
};

export const MAX_ATTRIBUTES_COUNT = 5;
export const MAX_LIKERT_QUESTIONS = 50;

export const RECORDING_STARTED_EVENT_NAME = "fbRecordingStarted";
